<style lang="scss" scoped>
@import './../assets/sass/main';

header {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
}

.navbar.slide-down-enter {
  position: fixed;
  top: -64px;
}

.navbar.slide-down-enter-active {
  transition: top 0.3s cubic-bezier(0, 0.76, 0.8, 0.97);
}

.navbar.slide-down-leave-active {
  transition: top 0.1s cubic-bezier(0, 0.76, 0.8, 0.97);
}

.navbar.slide-down-enter-to,
.navbar.slide-down-leave {
  top: 0px;
}

.navbar.slide-down-leave-to {
  top: -64px;
}

.navbar {
  // height: $navbar-height - 10;
  // top: -7px;
  // position: relative;
  height: 75px;

  img {
    width: 50px;
  }

  a.nav-link.primary,
  .mobile-link-trigger {
    cursor: pointer;
  }

  a.nav-link.outlined-btn {
    background-color: transparent !important;
    border-color: #e8e8e8 !important;
  }

  a.nav-link.outlined-btn:hover {
    border-color: #b03236 !important;
  }
}
</style>

<template lang="pug">
header
  .navbar.container-fluid(
    :class='{ alternate: useAlternate && !showMobileLinks }'
  )
    // router-link(:to='"/"').nav-title inom.ph
    router-link(:to='"/"')
      img(:src='"./../assets/img/logo_thumb.png"')
    ul.desktop-links.right.hide-on-large-only
      li
        a.mobile-link-trigger(@click='showMobileLinks = !showMobileLinks')
          i.material-icons(v-if='!showMobileLinks') menu
          i.material-icons(v-if='showMobileLinks') close
    ul.desktop-links.right.hide-on-med-and-down
      // li
        a.social-circle.white-text.icoFacebook(href="https://www.facebook.com/InomPhOfficial/", target="_blank", title="Facebook")
          i.fa.fa-facebook
      li
        //- router-link.nav-link(:to='"/drinks"' v-if='hasLocation') Drinks
        router-link.nav-link(:to='"/drinks"') Drinks
      //- li
      //-   //- router-link.nav-link(:to='"/stores"' v-if='hasLocation') Store
        router-link.nav-link(:to='"/stores"') Store
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/my-orders"') Orders
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/cart"') Cart
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/profile"') {{ user.displayName }}
      li(v-if='!isValidUser')
        router-link.nav-link.primary.outlined-btn(:to='"/login"') Log in
      li(v-else)
        a.nav-link.primary.outlined-btn(@click='logout') Log out

    ul.mobile-links.hide-on-large-only(v-if='showMobileLinks')
      li
        //- router-link.nav-link(:to='"/drinks"' v-if='hasLocation') Drinks
        router-link.nav-link(:to='"/drinks"') Drinks
      //- li
      //-   //- router-link.nav-link(:to='"/stores"' v-if='hasLocation') Store
        router-link.nav-link(:to='"/stores"') Store
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/my-orders"') Orders
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/cart"') Cart
      li(v-if='isValidUser')
        router-link.nav-link(:to='"/profile"') {{ user.displayName }}
      li(v-if='!isValidUser')
        router-link.nav-link.primary.outlined-btn(:to='"/login"') Log in
      li(v-else)
        a.nav-link.primary.outlined-btn(@click='logout') Log out
  transition(name='slide-down')
    .navbar.fixed.container-fluid(v-if='showFixedNavbar')
      // router-link(:to='"/"').nav-title inom.ph
      router-link(:to='"/"')
        img(:src='"./../assets/img/logo_thumb.png"')
      ul.desktop-links.right.hide-on-large-only
        li
          a.mobile-link-trigger(@click='showMobileLinks = !showMobileLinks')
            i.material-icons(v-if='!showMobileLinks') menu
            i.material-icons(v-if='showMobileLinks') close
      ul.desktop-links.right.hide-on-med-and-down
        // li
          a.social-circle.white-text.icoFacebook(href="https://www.facebook.com/InomPhOfficial/", target="_blank", title="Facebook")
            i.fa.fa-facebook
        li
          //- router-link.nav-link(:to='"/drinks"' v-if='hasLocation') Drinks
          router-link.nav-link(:to='"/drinks"') Drinks
        //- li
        //-   //- router-link.nav-link(:to='"/stores"' v-if='hasLocation') Store
        //-   router-link.nav-link(:to='"/stores"') Store
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/my-orders"') Orders
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/cart"') Cart
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/profile"') {{ user.displayName }}
        li(v-if='!isValidUser')
          router-link.nav-link.primary.outlined-btn(:to='"/login"') Log in
        li(v-else)
          a.nav-link.primary.outlined-btn(@click='logout') Log out

      ul.mobile-links.hide-on-large-only(v-if='showMobileLinks')
        li
          router-link.nav-link(:to='"/drinks"', :userlog='isValidUser') Drinks
        //- li
        //-   //- router-link.nav-link(:to='"/stores"' v-if='hasLocation') Store
        //-   router-link.nav-link(:to='"/stores"') Store
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/my-orders"') Orders
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/cart"') Cart
        li(v-if='isValidUser')
          router-link.nav-link(:to='"/profile"') {{ user.displayName }}
        li(v-if='!isValidUser')
          router-link.nav-link.primary.outlined-btn(:to='"/login"') Log in
        li(v-else)
          a.nav-link.primary.outlined-btn(@click='logout') Log out
</template>
<script>
export default {
  props: ['showFixed', 'useAlternate'],
  data() {
    return {
      alternate: this.useAlternate,
      showFixedNavbar: this.showFixed,
      showMobileLinks: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    hasLocation() {
      return !!this.$store.state.cart.location
    },
    isValidUser() {
      let user = this.$store.state.auth.user
      if (user) {
        if (user.type === 'reseller') {
          if (user.status === 'disabled' || user.status === 'application') {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },
  },
  watch: {
    $route() {
      this.showMobileLinks = false
    },
  },
  methods: {
    fix() {
      this.showFixedNavbar = true
    },
    unfix() {
      this.showFixedNavbar = false
    },
    login() {
      this.$router.push({
        name: 'login',
        query: { redirectUrl: this.$router.currentRoute.fullPath },
      })
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        localStorage.clear()
        this.$router.push({ path: '/login' })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-header.vue